import AclName from '../acl/AclName';
import model from '../models-v2/admin/system-task';

export default [
  {
    path: '/system-tasks',
    name: 'system-tasks-index',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      acl: AclName.SettingsPageSystemTaskList,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Zadania systemowe', url: '/system-tasks' },
      ],
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/system-tasks/edit/:id',
    name: 'system-tasks-edit',
    components: {
      default: () => import('../pages/model-form.vue'),
    },
    meta: {
      acl: AclName.SettingsPageSystemTaskEdit,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Zadania systemowe', url: '/system-tasks' },
        { title: 'Edycja', url: '' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
  },
];
